import { PrototypeLanding } from './prototype/PrototypeLanding';
import './v4.css';

/** Финальная композиция по прототипам: центрированный hero и стеклянные объекты. */
export const MainV4 = () => <PrototypeLanding />;
